import { CSSProperties } from "react";

// Exact values from the Figma footer spec that Bootstrap has no class for.
// Spacing uses Bootstrap classes in Footer.tsx where its scale is close enough.

export interface Styles {
  band: CSSProperties;
  card: CSSProperties;
  deco: CSSProperties;
  logo: CSSProperties;
  tagline: CSSProperties;
  badge: CSSProperties;
  heading: CSSProperties;
  link: CSSProperties;
  divider: CSSProperties;
  socialIcon: CSSProperties;
  hr: CSSProperties;
  copyright: CSSProperties;
}

const styles: Styles = {
  band: {
    backgroundColor: "#F1F7FC",
    borderRadius: "40px 40px 0 0",
    padding: "0 34px 14px",
  },
  card: {
    backgroundColor: "#F4F8FD",
    borderRadius: 40,
    boxShadow: "0 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "32px 41px 30px",
  },
  // Quarter shapes; each use adds its position and which corner is rounded
  deco: {
    width: 167,
    height: 188,
    backgroundColor: "#005BFF",
    opacity: 0.05,
    pointerEvents: "none",
    zIndex: 1,
  },
  logo: {
    width: 176,
    height: "auto",
  },
  tagline: {
    maxWidth: 413,
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 14,
    lineHeight: "23px",
    color: "#1A1B22",
  },
  // Larger than Figma's 64x19 so the drawn text stays legible
  badge: {
    height: 32,
    padding: "0 10px",
    border: "0.5px solid #A6A6A6",
  },
  heading: {
    fontFamily: "var(--primary-font-bold)",
    fontSize: 14,
    lineHeight: "20px",
    color: "#2563EB",
    marginBottom: 11,
  },
  link: {
    padding: "2px 0",
    fontFamily: "var(--primary-font-medium)",
    fontSize: 14,
    lineHeight: "20px",
    color: "#1A1B22",
  },
  divider: {
    backgroundColor: "rgba(120, 118, 123, 0.42)",
    opacity: 1,
  },
  socialIcon: {
    width: 60,
    height: 60,
    backgroundColor: "#E5EEF9",
    color: "#374151",
  },
  hr: {
    width: 359,
    maxWidth: "100%",
    borderTop: "0.5px solid rgba(120, 118, 123, 0.42)",
  },
  copyright: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 12,
    lineHeight: "16px",
    color: "#1A1B22",
  },
};

export default styles;
